import { useParams } from 'react-router-dom';
import { Scaffold } from 'layouts';
import { SchedulingLayout } from 'layouts/Scheduling';
import { ListOrders } from 'components/Pages/Scheduling/PaginatedOrders';

type OrderType = 'carregamento' | 'descarregamento';

export const ListOrdersPage = () => {
  const { orderType } = useParams<{ orderType: OrderType }>();

  return (
    <Scaffold>
      <SchedulingLayout>
        {orderType === 'carregamento' && <LoadingOrders />}
        {orderType === 'descarregamento' && <UnloadingOrders />}
      </SchedulingLayout>
    </Scaffold>
  );
};

const LoadingOrders = () => {
  return <ListOrders orderType={'1'} />
}

const UnloadingOrders = () => {
  return <ListOrders orderType={'2'} />
}